import { Paper, Tab, Tabs } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';
import { getAdminTabA11yProps } from '../constants';
import type { IDashboardTabsProps } from '../interfaces';

export const DashboardTabs = ({ tabs, activeSlug, baseUrl, onChange }: IDashboardTabsProps) => {
  const cleanBaseUrl = baseUrl.replace(/\/+$/, '');

  return (
    <Paper
      elevation={0}
      sx={{
        px: 0.75,
        py: 0.5,
        minWidth: 0,
        maxWidth: '100%',
        bgcolor: '#f4f4f5',
        borderRadius: 9999,
        border: '1px solid #e4e4e7',
        width: 'fit-content',
      }}
    >
      <Tabs
        value={activeSlug}
        onChange={onChange}
        aria-label="Dashboard navigation tabs"
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        sx={{
          minHeight: 32,
          '& .MuiTabs-indicator': { display: 'none' },
          '& .MuiTabs-flexContainer': { gap: 0.5 },
        }}
      >
        {tabs.map((tab) => (
          <Tab
            key={tab.slug}
            label={tab.label}
            value={tab.slug}
            component={Link}
            to={`${cleanBaseUrl}/${tab.slug}`}
            disableRipple
            sx={{
              minHeight: 30,
              px: 2,
              py: 0.5,
              fontSize: '0.8rem',
              fontWeight: 500,
              textTransform: 'none',
              borderRadius: 9999,
              color: '#71717a',
              transition: 'all 200ms cubic-bezier(0,0,0.2,1)',
              '&:hover': { color: '#18181b' },
              '&.Mui-selected': {
                bgcolor: '#ffffff',
                color: '#18181b',
                fontWeight: 600,
                boxShadow: '0 1px 3px rgba(0,0,0,0.08), 0 1px 2px rgba(0,0,0,0.04)',
              },
            }}
            {...getAdminTabA11yProps(tab.slug)}
          />
        ))}
      </Tabs>
    </Paper>
  );
};
